import { fetcher } from "utils";

type PostUsersCoordi = (params: { coordinationId: number | string }) => Promise<" ">;

export const post__users__coordi: PostUsersCoordi = ({ coordinationId }) =>
  fetcher.post("/users/coordi", { coordinationId: String(coordinationId) });
